import { Typography } from '@chr/eds-react';
import { Stack } from '@mui/material';
import './CargoSummaryItem.scss';
import { Measurement } from '../../apis/dtos';
import { WeightMeasurement } from '../measurement/WeightMeasurement';

interface CargoSummaryItemProps {
  title: string;
  textToDisplay?: string;
  measurementToDisplay?: Measurement;
  isMobileScreen: boolean;
  isWeight?: boolean;
}

export const CargoSummaryItem = ({
  title,
  textToDisplay,
  measurementToDisplay,
  isWeight,
  isMobileScreen,
}: CargoSummaryItemProps) => {
  return (
    <div
      data-testid="cargo-summary-item"
      className={
        isMobileScreen
          ? 'cargo-summary-item-container-mobile'
          : 'cargo-summary-item-container'
      }
    >
      <Stack
        direction={isMobileScreen ? 'row' : 'column'}
        justifyContent={isMobileScreen ? 'space-between' : 'flex-start'}
        spacing={isMobileScreen ? 2 : 1}
        width={'100%'}
      >
        <Typography variant="body1">{title}</Typography>
        {isWeight && measurementToDisplay && (
          <Typography variant="subtitle2">
            <WeightMeasurement {... measurementToDisplay } />
          </Typography>
        )}
        {!isWeight && (
          <Typography variant="subtitle2">{textToDisplay}</Typography>
        )}
      </Stack>
    </div>
  );
};
